import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Routes from './route'
import SeedOrdersTable from './SeedOrdersTable'
import SeedOrderAdd from './SeedOrderAdd'
import SeedOrderEdit from './SeedOrderEdit'
import SeedOrderDetails from './SeedOrdersDetail/SeedOrderDetails'

const SeedOrdersPage: React.FC = () => {
  return (
    <Switch>
      <Route path={Routes.List} exact={true}>
        <SeedOrdersTable />
      </Route>
      <Route path={Routes.SeedOrderAdd} exact={true}>
        <SeedOrderAdd />
      </Route>
      <Route path={Routes.SeedOrderEdit} exact={true}>
        <SeedOrderEdit />
      </Route>
      <Route path={Routes.SeedOrderDetails} exact={true}>
        <SeedOrderDetails />
      </Route>
      <Redirect to={Routes.List} />
    </Switch>
  )
}

export default SeedOrdersPage
